export const BHUTANESE_BANKS = [
  { id: "bob", name: "Bank of Bhutan" },
  { id: "bnb", name: "Bhutan National Bank" },
  { id: "dpnb", name: "Druk PNB Bank" },
  { id: "tbank", name: "T-Bank (Tashi Bank)" },
  { id: "bdb", name: "Bhutan Development Bank" },
  { id: "dkdb", name: "Druk Kidu Digital Bank" },
];

export const PAYMENT_METHODS = [
  { id: "bank_transfer", name: "Bank Transfer" },
  { id: "cash", name: "Cash" },
  { id: "cheque", name: "Cheque" },
  { id: "mobile_banking", name: "Mobile Banking" },
  { id: "online_payment", name: "Online Payment" },
];
